var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.showLoginDialog),callback:function ($$v) {_vm.showLoginDialog=$$v},expression:"showLoginDialog"}},[_c('Login',{attrs:{"isDialogOpen":_vm.showLoginDialog,"defaultOfficeCode":_vm.officeCode},on:{"loggedIn":_vm.loggedInEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }